import React from "react";

interface DropdownMenuItemProps {
  onClick: () => void;
  isSelected?: boolean;
  children: React.ReactNode;
  /** Extra classes appended last — e.g. to override the default `px-2`. */
  className?: string;
}

export function DropdownMenuItem({
  onClick,
  isSelected,
  children,
  className = "",
}: DropdownMenuItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full flex items-center justify-between item-height px-2 gap-2 cursor-pointer transition-colors ${
        isSelected ? "bg-accent/10" : "hover:bg-list-hover"
      } ${className}`}
    >
      {children}
    </button>
  );
}
